import { styled } from '@spazious/dollhouse-theme';

import { Typography } from '../Typography/index.js';

export const DialogTitle = styled(Typography)
  .attrs({
    variant: 'display',
  })
  .withConfig({
    displayName: 'DialogTitle',
  })`
  padding: 16px 24px;
  flex: 0 0 auto;
`;
